import { render, staticRenderFns } from "./StaffLabel.vue?vue&type=template&id=62f3774c&"
import script from "./StaffLabel.vue?vue&type=script&lang=js&"
export * from "./StaffLabel.vue?vue&type=script&lang=js&"
import style0 from "./StaffLabel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/01-qym-hop-newmall-frontend-k8s@3/mgr-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('62f3774c')) {
      api.createRecord('62f3774c', component.options)
    } else {
      api.reload('62f3774c', component.options)
    }
    module.hot.accept("./StaffLabel.vue?vue&type=template&id=62f3774c&", function () {
      api.rerender('62f3774c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/code/StaffLabel.vue"
export default component.exports